<template>
  <template
    v-for="productEnrichment in productEnrichments"
    :key="productEnrichment.sys.id + 'TabElement'"
  >
    <LibTabSections
      v-if="productEnrichment?.fields?.contentSlotTabElement"
      :entries="productEnrichment?.fields?.contentSlotTabElement"
    />
  </template>
</template>

<script setup lang="ts">
import type { IProductEnrichment } from '~~/lib/ContentfulService';

interface Props {
  productEnrichments: IProductEnrichment[];
}

defineProps<Props>();
</script>
